import { EasyField } from '../baseClasses/easyField';
import { FieldOptions, SelectOption } from '../index';

export class EasyRadioButtonField extends EasyField {
  controlType = 'radio-button';
  items: Array<SelectOption<any>>;

  constructor(options: FieldOptions<any> = {}) {
    super(options);
    options.controlType = this.controlType;
  }
}
